var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGluten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "gluten",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gluten") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gluten",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(32.000000, 16.000000)",
    fill: "#1A1919"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0480855,24.2419467 C17.2940855,25.4431467 16.448735,29.2069067 16.448735,29.2069067 C16.448735,29.2069067 20.6249231,31.2752 23.3789231,30.0734133 C26.1329231,28.8725067 27.4481709,24.3745333 27.4481709,24.3745333 C27.4481709,24.3745333 22.8020855,23.0407467 20.0480855,24.2419467",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0938462,17.0291733 C20.3395556,18.2303733 19.4942051,21.9941333 19.4942051,21.9941333 C19.4942051,21.9941333 23.6706838,24.0624267 26.4246838,22.8609333 C29.1786838,21.6597333 30.4945128,17.1614667 30.4945128,17.1614667 C30.4945128,17.1614667 25.8475556,15.8279733 23.0938462,17.0291733",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1396068,9.8164 C23.3856068,11.0178933 22.5402564,14.7816533 22.5402564,14.7816533 C22.5402564,14.7816533 26.716735,16.8496533 29.4701538,15.6484533 C32.224735,14.4472533 33.5402735,9.94928 33.5402735,9.94928 C33.5402735,9.94928 28.8938974,8.6152 26.1396068,9.8164",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8466325,2.79253333 C24.7191624,4.98402667 25.2739145,8.80674667 25.2739145,8.80674667 C25.2739145,8.80674667 29.884547,9.09274667 32.0120171,6.90125333 C34.1397778,4.70976 33.7602564,0.022 33.7602564,0.022 C33.7602564,0.022 28.9743932,0.601626667 26.8466325,2.79253333",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9412479,6.27997333 C16.9381026,3.33549333 19.0277949,0.149306667 19.0277949,0.149306667 C19.0277949,0.149306667 23.295812,1.99906667 24.2986667,4.94384 C25.3021026,7.88890667 23.0104444,11.9339733 23.0104444,11.9339733 C23.0104444,11.9339733 18.9441026,9.22474667 17.9412479,6.27997333",
    id: "Fill-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8954872,13.49304 C13.8920513,10.5479733 15.9817436,7.36178667 15.9817436,7.36178667 C15.9817436,7.36178667 20.2497607,9.21184 21.2531966,12.1566133 C22.2566325,15.1013867 19.9643932,19.14616 19.9643932,19.14616 C19.9643932,19.14616 15.8986325,16.4378133 14.8954872,13.49304",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8500171,20.70552 C10.8465812,17.76104 12.9362735,14.5742667 12.9362735,14.5742667 C12.9362735,14.5742667 17.2042906,16.4246133 18.2074359,19.3693867 C19.2105812,22.31416 16.9186325,26.3592267 16.9186325,26.3592267 C16.9186325,26.3592267 12.8528718,23.6502933 11.8500171,20.70552",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7250908,39.58416 C10.7184274,34.4593333 12.3594359,30.7794667 14.7780855,26.19848 L16.5504444,27.1500533 C14.1524274,31.7137333 12.7395385,34.91928 12.7328547,39.58416 C12.7328547,40.7836 12.8290427,42.08512 13.0344957,43.5330133 L13.0344957,43.5336 L11.047094,43.82136 C10.8300171,42.2922133 10.7250908,40.8930133 10.7250908,39.58416",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0344957,43.5330133 L11.047094,43.82136 C11.047094,43.82136 7.91124786,32.7098933 7.29459829,32.08744 C6.67765812,31.4646933 0.147333333,36.51824 0.147333333,36.51824 C0.147333333,36.51824 7.43960684,23.6643733 8.60054701,26.15448 C8.92688889,26.4838933 13.0344957,43.5330133 13.0344957,43.5330133",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    x: 21,
    y: 100,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "gluten"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGluten);
export default __webpack_public_path__ + "static/media/gluten.229442695e3a91f2f71a3908b07edb37.svg";
export { ForwardRef as ReactComponent };